/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ModelsRequestBuilderNavigationMetadata, ModelsRequestBuilderRequestsMetadata, type ModelsRequestBuilder } from './modelsRequests/index.js';
// @ts-ignore
import { OrderVolumeRequestBuilderNavigationMetadata, OrderVolumeRequestBuilderRequestsMetadata, type OrderVolumeRequestBuilder } from './orderVolume/index.js';
// @ts-ignore
import { SkuRequestBuilderNavigationMetadata, type SkuRequestBuilder } from './sku/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/forecasting
 */
export interface ForecastingRequestBuilder extends BaseRequestBuilder<ForecastingRequestBuilder> {
    /**
     * The models property
     */
    get models(): ModelsRequestBuilder;
    /**
     * The orderVolume property
     */
    get orderVolume(): OrderVolumeRequestBuilder;
    /**
     * The sku property
     */
    get sku(): SkuRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ForecastingRequestBuilderUriTemplate = "{+baseurl}/api/forecasting";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ForecastingRequestBuilderNavigationMetadata: Record<Exclude<keyof ForecastingRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    models: {
        requestsMetadata: ModelsRequestBuilderRequestsMetadata,
        navigationMetadata: ModelsRequestBuilderNavigationMetadata,
    },
    orderVolume: {
        requestsMetadata: OrderVolumeRequestBuilderRequestsMetadata,
        navigationMetadata: OrderVolumeRequestBuilderNavigationMetadata,
    },
    sku: {
        navigationMetadata: SkuRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
